import axios from 'axios'
import { urlTenantKey } from 'components/Providers'
import { generateClientToken } from './client-auth-token'

const openAxios = axios.create({
  baseURL: process.env.REACT_APP_API_HOST,
  headers: {
    'x-tenant-id': urlTenantKey,
  },
})

openAxios.interceptors.request.use(
  (config) => {
    // Inject client authentication token
    const campxClientId = process.env.REACT_APP_CLIENT_ID
    const campxClientSecret = process.env.REACT_APP_CAMPX_CLIENT_SECRET
    if (campxClientId && campxClientSecret) {
      config.headers.set(
        'x-campx-client',
        generateClientToken(campxClientId, campxClientSecret),
      )
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

export default openAxios
